import * as FuncionesServices from "../../utils/funciones-services";

export const obtenerSolicitudes = async (idSolicitudMultiple) => {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_SOLICITUDES, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token'              : 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : 'test'
        })
    })
}

export const actualizarSolicitud = async (idSolicitudMultiple, solicitud) => {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_PUT_SOLICITUDES, atributos),
        method: 'PUT',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Content-Type'              : 'application/json',
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token'              : 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : 'test'
        }),
        body: JSON.stringify(solicitud)
    })
}

export const obtenerPolizas = async (tipoDocumento, numeroDocumento, tipo) => {
    let parametros = [
        { campo: 'tipoDocumento', valor: tipoDocumento.trim() },
        { campo: 'numeroDocumento', valor: (tipoDocumento.trim() === 'CE'
            ? numeroDocumento.substring(numeroDocumento.length - 9, numeroDocumento.length) : numeroDocumento)},
        { campo: 'tipo', valor: tipo }
    ]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.agregarParametros(process.env.REACT_APP_WS_GET_LISTAR_POLIZAS, parametros),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Content-Type'              : 'application/json',
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token'              : 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : 'test'
        })
    })
}

export const guardarReemplazoTraspaso = async (idSolicitud, request) => {
    let atributos = [{ campo: 'idSolicitud', valor: idSolicitud }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_PUT_SOLICITUD_REEMPLAZO_TRASPASO, atributos),
        method: 'PUT',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Content-Type'              : 'application/json',
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token'              : 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : 'test'
        }),
        body: JSON.stringify(request)
    })
}